<button mat-button [ngStyle]="{'line-height.px': buttonHeight}" style="font-weight: 400; font-size: 12px;" (click)="btnClickedHandler()">{{text}}</button>